module.exports = __webpack_public_path__ + "img/to.70ca64cb.png";